import { ApiResponse, axiosInstance } from '@/lib/axios';
import { queryOptions, useQuery } from '@tanstack/react-query';
import { QueryConfig } from '@/lib/react-query';
import { TCASTChannel } from '../types/customer-survey.type';

/**
 * Get List CAST Channel Response Type
 */

export type TGetListCASTChannelResponse = ApiResponse<TCASTChannel[]>;

export const getListCASTChannel = async (): Promise<TGetListCASTChannelResponse> => {
  const url = '/csat/config/csat-channel';

  return axiosInstance.get(url);
};

/**
 * Get List CAST Channel React-Query Hook
 */
export const GET_LIST_CAST_CHANNEL_QUERY_KEY = 'get-list-cast-channel';

export const getListCASTChannelQueryOptions = <TData = TCASTChannel[]>(
  select?: (data: TGetListCASTChannelResponse) => TData
) => {
  return queryOptions({
    queryKey: [GET_LIST_CAST_CHANNEL_QUERY_KEY],
    queryFn: () => getListCASTChannel(),
    select,
  });
};

// Overload when select is provided - returns transformed type
export function useGetListCASTChannelQuery<TData>(options: {
  queryConfig?: QueryConfig<typeof getListCASTChannelQueryOptions<TData>>;
  select: (data: TGetListCASTChannelResponse) => TData;
}): ReturnType<typeof useQuery<TData>>;

// Overload when select is not provided - returns raw API response (even if generic is provided)
export function useGetListCASTChannelQuery(options: {
  queryConfig?: QueryConfig<typeof getListCASTChannelQueryOptions<TGetListCASTChannelResponse>>;
}): ReturnType<typeof useQuery<TGetListCASTChannelResponse>>;

// Implementation
export function useGetListCASTChannelQuery<TData = TGetListCASTChannelResponse>({
  queryConfig,
  select,
}: {
  queryConfig?: QueryConfig<typeof getListCASTChannelQueryOptions<TData | TGetListCASTChannelResponse>>;
  select?: (data: TGetListCASTChannelResponse) => TData;
}) {
  return useQuery({
    ...getListCASTChannelQueryOptions(select),
    ...queryConfig,
  }) as ReturnType<typeof useQuery<TData extends TGetListCASTChannelResponse ? TGetListCASTChannelResponse : TData>>;
}

// Backward compatibility - deprecated
/**
 * @deprecated Use useGetListCASTQuestionConfigQuery instead
 */
export const useGetListCASTChannel = useGetListCASTChannelQuery;
